// /*
//  * Free-gift automation.
//  * Keeps exactly QTY of the $0 gift product in the cart whenever there is >= 1 paid item.
//  * Removes it when the cart has no paid items or the feature is disabled.
//  * Reacts to every cart:update (and on load), dispatches a source-tagged cart:update so the
//  * header/cart UI refresh without re-triggering this reconcile.
//  */
// (function () {
//   var G = window.PEP_GIFT || {};
//   if (!G.handle || !G.variantId) return;

//   var QTY = 1; // 1 free gift per ORDER. For 1 per paid item, set QTY = paidCount inside reconcile().
//   var busy = false;

//   function root() {
//     return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
//   }
//   function cartJs() {
//     return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
//   }
//   function post(u, b) {
//     return fetch(root() + u, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
//       body: JSON.stringify(b)
//     }).then(function (r) { return r.json().catch(function () { return {}; }); });
//   }

//   function reconcile() {
//     if (busy) return;
//     busy = true;
//     var added = false;
//     return cartJs().then(function (cart) {
//       var gift = null, paid = 0;
//       (cart.items || []).forEach(function (i) {
//         if (i.handle === G.handle) gift = i; else paid += i.quantity;
//       });
//       var enabled = G.enabled !== false;
//       var want = (enabled && paid > 0) ? QTY : 0;
//       var have = gift ? gift.quantity : 0;
//       if (have === want) return null;
//       if (want === 0) return post('cart/change.js', { id: gift.key, quantity: 0 });
//       if (!gift && G.available === false) return null; // can't add out-of-stock; don't spam
//       if (!gift) { added = true; return post('cart/add.js', { id: G.variantId, quantity: want }); }
//       return post('cart/change.js', { id: gift.key, quantity: want });
//     }).then(function (changed) {
//       if (!changed) return;
//       if (added && G.showPopup !== false) showToast(G.message);
//       return cartJs().then(function (c) {
//         document.dispatchEvent(new CustomEvent('cart:update', {
//           bubbles: true,
//           detail: { data: { itemCount: c.item_count, source: 'pep-free-gift' } }
//         }));
//       });
//     }).catch(function () {}).finally(function () { busy = false; });
//   }

//   // ----- Toast -----
//   var toastEl, toastTimer;
//   function buildToast() {
//     if (toastEl) return toastEl;
//     toastEl = document.createElement('div');
//     toastEl.className = 'pep-gift-toast';
//     toastEl.setAttribute('role', 'status');
//     toastEl.innerHTML =
//       '<span class="pep-gift-toast__icon" aria-hidden="true">🎁</span>' +
//       '<span class="pep-gift-toast__msg"></span>' +
//       '<button class="pep-gift-toast__close" type="button" aria-label="Dismiss">✕</button>';
//     document.body.appendChild(toastEl);
//     toastEl.querySelector('.pep-gift-toast__close').addEventListener('click', hideToast);
//     return toastEl;
//   }
//   function showToast(msg) {
//     var el = buildToast();
//     el.querySelector('.pep-gift-toast__msg').textContent = msg || 'Free gift added to your order!';
//     // restart the pop animation
//     el.classList.remove('is-visible');
//     void el.offsetWidth;
//     el.classList.add('is-visible');
//     clearTimeout(toastTimer);
//     toastTimer = setTimeout(hideToast, 4500);
//   }
//   function hideToast() {
//     if (toastEl) toastEl.classList.remove('is-visible');
//     clearTimeout(toastTimer);
//   }

//   // ----- Wire up -----
//   document.addEventListener('cart:update', function (e) {
//     if (e && e.detail && e.detail.data && e.detail.data.source === 'pep-free-gift') return; // ignore our own
//     reconcile();
//   });

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', reconcile);
//   } else {
//     reconcile();
//   }
// })();



/*
 * Free-gift automation with 5-Amino-1MQ at $250 threshold
 * WITH PROGRESS BAR (forced-visible container so theme CSS can't hide it,
 * AND self-healing: a MutationObserver re-inserts it if any other script's
 * re-render wipes it out — see note above ensureProgressBarPresent()).
 */
(function () {
  var G = window.PEP_GIFT || {};
  if (!G.handle || !G.variantId) return;

  var QTY = 1;
  var busy = false;
  var FREE_THRESHOLD = 250;
  var AMINO_HANDLE = '5-amino-1mq-free-item';
  var AMINO_VARIANT_ID = 49126763954276;

  // Cache of the last cart we rendered, so the self-heal observer can redraw
  // the bar immediately (from memory) instead of waiting on a network round trip.
  var lastCart = null;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function cartJs() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function post(u, b) {
    return fetch(root() + u, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(b)
    }).then(function (r) { return r.json().catch(function () { return {}; }); });
  }

  // ----- Progress Bar -----
  // Force these styles directly on the elements (inline) so no theme
  // stylesheet (overflow:hidden, height:0, display:none child-selectors,
  // etc.) can hide them.
  function forceVisible(el) {
    el.style.setProperty('display', 'block', 'important');
    el.style.setProperty('visibility', 'visible', 'important');
    el.style.setProperty('opacity', '1', 'important');
    el.style.setProperty('height', 'auto', 'important');
    el.style.setProperty('max-height', 'none', 'important');
    el.style.setProperty('overflow', 'visible', 'important');
    el.style.setProperty('position', 'relative', 'important');
    el.style.setProperty('z-index', '9999', 'important');
    el.style.setProperty('margin', '16px 0', 'important');
    el.style.setProperty('padding', '12px 14px', 'important');
    el.style.setProperty('border', '1px solid #e5e5e5', 'important');
    el.style.setProperty('border-radius', '8px', 'important');
    el.style.setProperty('background', '#fafafa', 'important');
  }

  function updateProgressBar(cart) {
    lastCart = cart;

    var totalPrice = 0;

    (cart.items || []).forEach(function (i) {
      totalPrice += i.price * i.quantity;
    });

    var totalDollars = totalPrice / 100;
    var progress = Math.min((totalDollars / FREE_THRESHOLD) * 100, 100);
    var remaining = Math.max(FREE_THRESHOLD - totalDollars, 0);

    var container = document.getElementById('pep-gift-progress');
    if (!container) {
      container = document.createElement('div');
      container.id = 'pep-gift-progress';

      var candidates = [
        '#cart-form',
        '.cart-page__items',
        'cart-drawer-items',
        'cart-items',
        '.cart__items',
        '.cart-items',
        'form[action="/cart"]',
        '#CartDrawer-Form',
        '#cart',
        '#CartForm',
        'main'
      ];

      var inserted = false;
      for (var i = 0; i < candidates.length; i++) {
        var el = document.querySelector(candidates[i]);
        if (el && el.parentNode) {
          el.parentNode.insertBefore(container, el.nextSibling);
          inserted = true;
          console.log('[pep-gift] progress bar inserted after selector:', candidates[i]);
          break;
        }
      }
      if (!inserted) {
        console.warn('[pep-gift] no known cart container found; appending to <body>.');
        document.body.insertBefore(container, document.body.firstChild);
      }
    }

    forceVisible(container);

    var rect = container.getBoundingClientRect();
    console.log('[pep-gift] updateProgressBar:', {
      items: cart.items.length,
      totalDollars: totalDollars,
      containerInDom: document.body.contains(container),
      width: rect.width,
      height: rect.height,
      top: rect.top
    });

    if (cart.items.length === 0) {
      container.style.setProperty('display', 'none', 'important');
    } else if (totalDollars >= FREE_THRESHOLD) {
      container.innerHTML = `
        <div style="display:flex;justify-content:space-between;align-items:center;font-size:14px;font-weight:600;margin-bottom:8px;">
          <span>🎉 FREE 5-Amino-1MQ Unlocked!</span>
          <span>✅</span>
        </div>
        <div style="width:100%;height:8px;background:#e5e5e5;border-radius:4px;overflow:hidden;">
          <div style="height:100%;width:100%;background:#2e7d32;border-radius:4px;"></div>
        </div>
        <div style="display:flex;justify-content:space-between;font-size:12px;color:#666;margin-top:6px;">
          <span>🎁 Free gift added to your cart!</span>
        </div>
      `;
    } else {
      container.innerHTML = `
        <div style="display:flex;justify-content:space-between;align-items:center;font-size:14px;font-weight:600;margin-bottom:8px;">
          <span>🎁 Add $${remaining.toFixed(2)} more to get FREE 5-Amino-1MQ!</span>
          <span>${Math.round(progress)}%</span>
        </div>
        <div style="width:100%;height:8px;background:#e5e5e5;border-radius:4px;overflow:hidden;">
          <div style="height:100%;width:${progress}%;background:#111;border-radius:4px;transition:width .3s ease;"></div>
        </div>
        <div style="display:flex;justify-content:space-between;font-size:12px;color:#666;margin-top:6px;">
          <span>$${totalDollars.toFixed(2)} of $${FREE_THRESHOLD}</span>
          <span>🎯 $${FREE_THRESHOLD}</span>
        </div>
      `;
    }
  }

  // ─────────────────────────────────────────────────
  // SELF-HEALING PROGRESS BAR
  // reconcile() only dispatches its own 'cart:update' event when it actually
  // adds/removes a gift line — i.e. exactly when the cart crosses the $250
  // threshold. The theme (or any other script) may react to that event by
  // re-rendering the cart drawer/page markup, and since #pep-gift-progress
  // was inserted manually (it isn't part of the theme's own template), that
  // re-render wipes it out. This observer watches for the container going
  // missing and puts it straight back using the last cart we know about, so
  // the bar survives re-renders it didn't cause and doesn't control.
  // ─────────────────────────────────────────────────
  var healPending = false;
  function ensureProgressBarPresent() {
    if (document.getElementById('pep-gift-progress')) return;
    if (healPending) return;
    healPending = true;
    // rAF lets the re-render that just removed the bar finish first, so we
    // don't reinsert into a container that's mid-replacement itself.
    requestAnimationFrame(function () {
      healPending = false;
      if (document.getElementById('pep-gift-progress')) return;
      if (lastCart) {
        updateProgressBar(lastCart);
      } else {
        cartJs().then(updateProgressBar);
      }
    });
  }

  function watchProgressBar() {
    var observer = new MutationObserver(function () { ensureProgressBarPresent(); });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function reconcile() {
    if (busy) return;
    busy = true;
    var added = false;
    var aminoAdded = false;

    return cartJs().then(function (cart) {
      updateProgressBar(cart);

      var gift = null, paid = 0, totalPrice = 0;
      var aminoGift = null;

      (cart.items || []).forEach(function (i) {
        totalPrice += i.price * i.quantity;
        if (i.handle === G.handle) gift = i;
        else if (i.handle === AMINO_HANDLE) aminoGift = i;
        else paid += i.quantity;
      });

      var totalDollars = totalPrice / 100;

      var enabled = G.enabled !== false;
      var want = (enabled && paid > 0) ? QTY : 0;
      var have = gift ? gift.quantity : 0;

      var wantAmino = (enabled && totalDollars >= FREE_THRESHOLD) ? 1 : 0;
      var haveAmino = aminoGift ? aminoGift.quantity : 0;

      var promises = [];

      if (have !== want) {
        if (want === 0 && gift) {
          promises.push(post('cart/change.js', { id: gift.key, quantity: 0 }));
        } else if (!gift && G.available === false) {
          // don't spam
        } else if (!gift) {
          added = true;
          promises.push(post('cart/add.js', { id: G.variantId, quantity: want, properties: { '_gift': 'true' } }));
        } else if (gift) {
          promises.push(post('cart/change.js', { id: gift.key, quantity: want }));
        }
      }

      if (haveAmino !== wantAmino) {
        if (wantAmino === 0 && aminoGift) {
          promises.push(post('cart/change.js', { id: aminoGift.key, quantity: 0 }));
        } else if (wantAmino === 1 && !aminoGift) {
          aminoAdded = true;
          promises.push(post('cart/add.js', { id: AMINO_VARIANT_ID, quantity: 1, properties: { '_gift': 'true' } }));
        } else if (wantAmino === 1 && aminoGift && haveAmino !== 1) {
          promises.push(post('cart/change.js', { id: aminoGift.key, quantity: 1 }));
        }
      }

      if (promises.length === 0) return null;

      return Promise.all(promises).then(function (results) {
        var changed = results.some(function (r) { return r !== undefined && r !== null && !r.errors; });
        if (!changed) return null;
        return { changed: changed, added: added, aminoAdded: aminoAdded };
      });

    }).then(function (result) {
      if (!result) return;

      var messages = [];
      if (result.added && G.showPopup !== false) {
        messages.push(G.message || 'Free gift added to your order!');
      }
      if (result.aminoAdded) {
        messages.push('🎉 Free 5-Amino-1MQ added for orders over $250!');
      }
      if (messages.length > 0) {
        showToast(messages.join(' '));
      }

      return cartJs().then(function (c) {
        updateProgressBar(c);
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: { itemCount: c.item_count, source: 'pep-free-gift' } }
        }));

        // The dispatch above may trigger the theme's own cart re-render, which can
        // remove #pep-gift-progress a moment later (see watchProgressBar above).
        // These two delayed re-affirmations catch that without needing to know the
        // theme's exact re-render timing — mirrors the re-lock pattern used for
        // the recon gift's row-lock CSS on the other store's theme.
        setTimeout(ensureProgressBarPresent, 150);
        setTimeout(ensureProgressBarPresent, 500);
      });
    }).catch(function (err) {
      console.error('Free gift error:', err);
    }).finally(function () { busy = false; });
  }

  // ----- Toast -----
  var toastEl, toastTimer;
  function buildToast() {
    if (toastEl) return toastEl;
    toastEl = document.createElement('div');
    toastEl.className = 'pep-gift-toast';
    toastEl.setAttribute('role', 'status');
    toastEl.innerHTML =
      '<span class="pep-gift-toast__icon" aria-hidden="true">🎁</span>' +
      '<span class="pep-gift-toast__msg"></span>' +
      '<button class="pep-gift-toast__close" type="button" aria-label="Dismiss">✕</button>';
    document.body.appendChild(toastEl);
    toastEl.querySelector('.pep-gift-toast__close').addEventListener('click', hideToast);
    return toastEl;
  }
  function showToast(msg) {
    var el = buildToast();
    el.querySelector('.pep-gift-toast__msg').textContent = msg || 'Free gift added to your order!';
    el.classList.remove('is-visible');
    void el.offsetWidth;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 4500);
  }
  function hideToast() {
    if (toastEl) toastEl.classList.remove('is-visible');
    clearTimeout(toastTimer);
  }

  // ----- Wire up -----
  document.addEventListener('cart:update', function (e) {
    if (e && e.detail && e.detail.data && e.detail.data.source === 'pep-free-gift') return;
    reconcile();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      reconcile();
      watchProgressBar();
    });
  } else {
    reconcile();
    watchProgressBar();
  }
})();